import Trade from './trade'
export default Trade
